<template>
  <v-container fill-height>
    <v-row
      align="center"
      justify="center"
      no-gutters
    >
      <v-col cols="12" sm="7" md="5" xl="3">
        <v-card class="px-7 pt-2 pb-4 mx-auto primary text-center" outlined>
          <div style="text-align: center; width: 100%">
            <img style="max-height: 90px" :src="cadeado"/>
          </div>
          <span style="color: white">
            Identifique o dispositivo:
          </span>
          <v-form autocomplete="off">
            <v-text-field
              id="dispositivo"
              v-model="dispositivo"
              style="font-size: 13px"
              class="mt-2 px-3"
              spellcheck="false"
              :disabled="desabilitarBtns"
              @keyup.enter="formSubmitSolicitar()"
              placeholder=" "
              hide-details
              autofocus
              dense
              solo
            />
            <div class="text-left pl-6 mt-2">
              <span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">Exemplos:</span>
              <br><span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">- <strong>COMPUTADOR DA SALA 01</strong></span>
              <br><span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">- <strong>NOTEBOOK DO JUNIOR</strong></span>
              <br><span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">- <strong>CELULAR DA MARIA</strong></span>
            </div>
            <v-btn class="mt-3" @click="formSubmitSolicitar()" :disabled="desabilitarBtns" color="success">
              <v-icon class="mr-2">mdi-email-outline</v-icon>
              Solicitar Chave de Liberação
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card width="450px" class="mt-3 mx-auto" flat>
          <v-row no-gutters>
            <v-col>
              <v-form autocomplete="off" class="mt-3 px-7" style="text-align: center">
                <span style="font-size: 14px; font-weight: 300; letter-spacing: .5px">Dispositivo <b>Desconhecido</b></span>
                <v-text-field
                  class="mt-5"
                  height="37px"
                  type="text"
                  id="chave"
                  v-model="chave"
                  @keyup.enter="formSubmit()"
                  label="Chave de Liberação"
                  placeholder="Digite aqui a chave enviada por e-mail."
                  style="font-size: 13px"
                  spellcheck="false"
                  outlined
                  dense
                />
                <v-btn block @click="formSubmit()" :disabled="desabilitarBtns" class="mt-n2" color="primary">
                  Liberar Dispositivo
                </v-btn>
              </v-form>
              <div class="text-center my-6">
                <router-link v-show="!desabilitarBtns" to="signIn">
                  <span style="line-height: 16px; font-size: 13px">Voltar para o <b>Login</b></span>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as deviceAPI from '@/api/device'

export default {
  metaInfo: {
    title: 'Dispositivo Desconhecido'
  },
  data () {
    return {
      retorno: '',
      dispositivo: '',
      chave: '',
      desabilitarBtns: false,
      bgImage: require('@/assets/images/map1.jpg'),
      logo: require('@/assets/images/logo.png'),
      cadeado: require('@/assets/images/cadeado.png')
    }
  },
  computed: {
    ...mapGetters('device', ['getDevice', 'getEmailRetorno']),
    ...mapGetters('authData', ['loggedInUser'])
  },
  watch: {
    getEmailRetorno () {
      this.retorno = this.getEmailRetorno.msg
    }
  },
  mounted () {
    if (!this.loggedInUser || !this.getDevice.fingerprint) this.$router.push('/app/sessions/signIn')
  },
  methods: {
    ...mapActions('device', ['editDevice', 'findDevice', 'enviarEmailNovoDispositivo']),
    ...mapMutations('global', ['setLoading', 'setShowAnimation']),
    async formSubmitSolicitar () {
      this.setLoading(true)
      this.dispositivo = this.dispositivo.toUpperCase()
      this.desabilitarBtns = true
      if (this.dispositivo === '') {
        this.$toast.error('Digite a identificação para este dispositivo!')
      } else {
        const device = Object.assign({}, this.getDevice)
        device.device = this.dispositivo
        await this.editDevice(device)
        const deviceEmail = Object.assign({}, device)
        deviceEmail.email = process.env.VUE_APP_EMAIL_ADMINISTRADOR
        deviceEmail.usuario = this.loggedInUser.nome
        await this.enviarEmailNovoDispositivo(deviceEmail)
        this.$toast.warning('Chave enviada para o email: ' + deviceEmail.email)
      }
      this.desabilitarBtns = false
      this.setLoading(false)
    },
    async formSubmit () {
      this.setLoading(true)
      this.desabilitarBtns = true
      if (this.chave === '') {
        this.$toast.error('Digite a Chave, ela é obrigatória!', 'Erro!')
        this.desabilitarBtns = false
      } else {
        try {
          await deviceAPI.validaChaveLiberacao({ chave: this.chave, fingerprint: this.getDevice.fingerprint })
          this.setShowAnimation(true)
          window.localStorage.setItem('fingerprint', this.getDevice.fingerprint)
          this.$toast.success('Redirecionando...', 'Chave validada com sucesso!', { timeout: 2500 })
          const deviceResult = await this.findDevice(this.getDevice.fingerprint)
          const Obj = Object.assign({}, deviceResult)
          Obj.liberado = 'S'
          // Atualiza o dispositivo para liberado
          await this.editDevice(Obj)
          setTimeout(() => {
            this.setShowAnimation(false)
            this.desabilitarBtns = false
            this.$router.push('/app/relatorios/tabela-lucratividade') // alterado de / para isso para dar o refresh na pagina devido eu ter fixado o home pra essa pagina
          }, 2500)
        } catch (error) {
          this.$toast.error('A chave informada é inválida!', 'Erro!')
          this.desabilitarBtns = false
        }
      }
      this.setLoading(false)
    }
  }
}
</script>

<style scoped>
.fs-logotipo-login {
  width: 100px !important;
  margin-top: 30px;
  margin-left: 142px;
}
.fs-img-auth {
  margin-top: 10px;
  width: 90px !important;
}
strong {
  font-weight: 500;
  letter-spacing: .6px;
}
</style>
